const AUTO_SCROLL_THRESHOLD_PX = 160;

export function getMessagesDiv(): HTMLElement | null {
  return document.getElementById('messages');
}

export function getSendBtn(): HTMLElement | null {
  return document.getElementById('send-btn');
}

export function getAbortBtn(): HTMLElement | null {
  return document.getElementById('abort-btn');
}

export function getMsgInput(): HTMLTextAreaElement | null {
  return document.getElementById('msg-input') as HTMLTextAreaElement | null;
}

export function getScrollbarEl(): HTMLElement | null {
  return document.getElementById('custom-scrollbar');
}

export function getScrollbarThumb(): HTMLElement | null {
  return document.getElementById('custom-scrollbar-thumb');
}

export function getScrollBottomBtn(): HTMLButtonElement | null {
  return document.getElementById('scroll-bottom-btn') as HTMLButtonElement | null;
}

export function isNearBottom(
  element: HTMLElement | null,
  threshold = AUTO_SCROLL_THRESHOLD_PX,
): boolean {
  if (!element) return true;
  return (element.scrollHeight - element.clientHeight - element.scrollTop) <= threshold;
}

export { AUTO_SCROLL_THRESHOLD_PX };
